import { render, staticRenderFns } from "./AppMultipleFileSquare.vue?vue&type=template&id=51b1b710&scoped=true&"
import script from "./AppMultipleFileSquare.vue?vue&type=script&lang=js&"
export * from "./AppMultipleFileSquare.vue?vue&type=script&lang=js&"
import style0 from "./AppMultipleFileSquare.vue?vue&type=style&index=0&id=51b1b710&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1b710",
  null
  
)

export default component.exports